import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface AllSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  successTrackingIds: string[];
}

const AllSuccessModal = ({ isOpen, onClose, successTrackingIds }: AllSuccessModalProps) => {
  const theme = useTheme();
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Guías generadas con éxito"
        actions={
          <Button
            variant="contained"
            onClick={() => {
              onClose();
            }}
          >
            Cerrar
          </Button>
        }
      >
        <Typography
          variant="body1"
          sx={{ padding: '1rem', color: theme.palette.grey[500], textAlign: 'center' }}
        >
          Se han generado correctamente las guías para las órdenes del día.
        </Typography>

        {successTrackingIds.length > 0 && (
          <Box sx={{ padding: '1rem', textAlign: 'center' }}>
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              color={theme.palette.primary.main}
              sx={{ marginBottom: '0.5rem' }}
            >
              Guías generadas:
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                maxHeight: '200px',
                overflowY: 'auto',
                padding: '0.5rem',
              }}
            >
              {successTrackingIds.map((trackingId, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  sx={{
                    color: theme.palette.grey[700],
                    fontFamily: 'monospace',
                    backgroundColor: theme.palette.grey[100],
                    padding: '0.5rem',
                    borderRadius: '4px',
                  }}
                >
                  {trackingId}
                </Typography>
              ))}
            </Box>
          </Box>
        )}
      </Modal>
    </>
  );
};

export default AllSuccessModal;
